import { motion, useReducedMotion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTROL } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";

// UX-CP-01 §1 "At-risk gyms panel — deterministic flags (dunning, near-expiry license, low
// usage), each with a reason". Sourced from `/control/platform-summary`'s at_risk_gyms, computed
// server-side in routers/control.py's platform_summary() — same "AI-without-AI" honesty as the
// gym-side Needs Attention panel.
export function AtRiskGymsPanel({ gyms, loading }) {
  const reducedMotion = useReducedMotion();
  if (loading) {
    return <div className="solid-surface rounded-[14px] p-5 h-40 animate-pulse" data-testid={CONTROL.atRiskPanel} />;
  }
  return (
    <div className="solid-surface rounded-[14px] p-5" data-testid={CONTROL.atRiskPanel}>
      <p className="eyebrow mb-3">At-risk gyms</p>
      {(!gyms || gyms.length === 0) ? (
        <p className="text-sm py-4" style={{ color: "var(--scarlet-text-secondary)" }}>No gyms flagged — every tenant looks healthy.</p>
      ) : (
        <div className="space-y-1">
          {gyms.map((g, i) => (
            <motion.div key={g.organization_id} {...fadeUp(reducedMotion, i * 0.04, 6)}>
              <Link to={`/kairoo/gyms/${g.organization_id}`} data-testid={CONTROL.atRiskRow(g.organization_id)} className="flex items-start gap-3 p-2.5 rounded-[10px] hover:bg-black/[0.03] scarlet-focusable">
                <AlertTriangle size={16} className="mt-0.5 shrink-0" style={{ color: "var(--status-expiring-text)" }} />
                <div>
                  <p className="text-sm font-medium" style={{ color: "var(--scarlet-text)" }}>{g.display_name}</p>
                  <p className="text-xs" style={{ color: "var(--scarlet-text-secondary)" }}>{g.reasons.join(" · ")}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
